var Global = {
    /*************** Desarrollo *****************/
    //API REST de AZURE
    //apiRESTUrl : "http://localhost:3001/api",

    //Google Cloud Platform
    //google_API_KEY: "",
        
    /*************** Produccion *****************/
    //API REST de AZURE
    apiRESTUrl : "https://webapigovinetnodejs.azurewebsites.net/api",

    //Google Cloud Platform --PROD
    google_API_KEY: "AIzaSyD6HNzqPbmI2QRQyfrUDu9DuoY5BLikyIU", 
    // IMPLEMENTACION API KEY 2025-11-05
    APIKey : "370dc5ea-1c53-4f2a-af50-4aad99eb5b79",
    

    /*************** Generales *****************/    
    //Google Maps Platform
    google_maps_URL: "https://www.google.com/maps/dir/?api=1&destination=",

    fotos_URL: "https://storagegovi.blob.core.windows.net/fotos/i_",

    foto_nd: "https://storagegovi.blob.core.windows.net/fotos/img_nd.png"
};

export default Global;